export default "__VITE_ASSET__DFpdJ1aI__"